import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';

@Component({
  selector: 'app-pagination',
  imports: [CommonModule, DesyAngularModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent {
  @Input() paginationSize: number = 0;
  @Input() totalItems: number = 0;
  @Input() currentPage: number = 1;

  @Output() paginationSizeChange = new EventEmitter<number>();
  @Output() currentPageChange = new EventEmitter<number>();

  cambiarPagina(page: number) {
    this.currentPage = page;
    this.currentPageChange.emit(page);
  }

  cambiarPageSize(size: number) {
    this.paginationSize = size;
    this.paginationSizeChange.emit(size);
  }
}
